import { useQuery } from 'react-query'

import { nextStepsConstants } from 'features/catalog/constants'
// bully ignore[no-cross-feature-private-imports: createDefaultPanel is the canonical v2 panel constructor, the same one use-charts-v2-state.ts/catalog/keywords/feedback hash-payload builders already use. follow-up: .agents/follow-ups/bully-typescript-cross-feature-hooks.md]
import { createDefaultPanel } from 'features/charts-v2/store'
// bully ignore[no-cross-feature-private-imports: the canonical single-panel ChartsV2State envelope builder, reused across catalog/ask-yogi cross-page hash links. follow-up: .agents/follow-ups/bully-typescript-cross-feature-hooks.md]
import { buildChartsV2State } from 'features/charts-v2/utils/chart-artifact-to-panels'
// bully ignore[no-cross-feature-private-imports: the established v1<->v2 seam already used by use-charts-v2-state.ts. follow-up: .agents/follow-ups/bully-typescript-cross-feature-hooks.md]
import { translateV1FiltersToPanel } from 'features/charts-v2/utils/translate-v1-filters-to-panel'
// bully ignore[no-cross-feature-private-imports: type-only import; ScreenLinkService is injected by the caller (CatalogDetail, features/detail/Container.tsx), never constructed here. follow-up: .agents/follow-ups/bully-typescript-cross-feature-hooks.md]
import type { ScreenLinkService } from 'features/project/url-params/service'
import { Filters } from 'types/project'

export type Step =
  (typeof nextStepsConstants)[keyof typeof nextStepsConstants][number]

/** Wraps `screenLinkService.createFilterHash` as a query — called a fixed 3
 * times by `useCatalogDetailHeaderLinks` (Feedback, Charts, Keywords), not in
 * a loop, so rules-of-hooks holds.
 *
 * Every destination gets a v2-only hash body: the page's filters on a default
 * panel. The Charts step also carries the panel fields that select its chart
 * (`chartPanel`, see `catalog/constants.ts`).
 */
export function useFilterHashLink(
  screenLinkService: ScreenLinkService,
  projectId: string,
  step: Step,
  filters: Filters,
): string | undefined {
  const { data } = useQuery(
    ['getFilterHash', step.title, projectId, filters],
    () => {
      const basePanel = createDefaultPanel(0)
      const panel = {
        ...basePanel,
        ...translateV1FiltersToPanel(filters, basePanel),
        ...('chartPanel' in step ? step.chartPanel : {}),
      }
      return screenLinkService.createFilterHash(projectId, {
        page: step.page,
        filterString: JSON.stringify(buildChartsV2State([panel])),
      })
    },
    { enabled: !!projectId },
  )
  return data
}
